import React from 'react';

// Single source of truth for status → color across the app (job list rows/cards,
// the status pill itself, and anything else that wants to visually match it).
// Every status gets its own hue — none share a color, so each stage of the
// pipeline is instantly tellable apart at a glance.
const STATUS_COLORS = {
  default:             { bg: 'var(--status-pill-default-bg)',    color: 'var(--status-pill-default-text)' },
  sold:                { bg: 'var(--status-pill-sold-bg)',       color: 'var(--status-text-bold-amber)' },
  awaiting_production: { bg: 'var(--status-pill-awaiting-bg)',   color: 'var(--status-text-bold-orange)' },
  in_production:       { bg: 'var(--status-pill-prod-bg)',       color: 'var(--status-text-bold-blue)' },
  ready_for_install:   { bg: 'var(--status-pill-ready-bg)',      color: 'var(--status-text-bold-purple)' },
  ready_for_pickup:    { bg: 'var(--status-pill-pickup-bg)',     color: 'var(--status-text-bold-teal)' },
  scheduled:           { bg: 'var(--status-pill-scheduled-bg)',  color: 'var(--status-text-bold-indigo)' },
  on_hold:             { bg: 'var(--status-pill-hold-bg)',       color: 'var(--status-text-bold-rose)' },
  completed:           { bg: 'var(--status-pill-completed-bg)',  color: 'var(--status-text-bold-green)' },
  cancelled:           { bg: 'var(--status-pill-cancelled-bg)',  color: 'var(--status-text-bold-red)' }
};

export function getStatusColors(status) {
  return STATUS_COLORS[status] || STATUS_COLORS.default;
}

export default function Badge({ children, status = 'default', style }) {
  const colors = getStatusColors(status);

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: '4px 12px',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: '600',
      background: colors.bg,
      color: colors.color,
      ...style
    }}>
      {children}
    </span>
  );
}
